export default {
      id: "domodedovo-usage",
      viewBox: "0 0 221 40",
      url: __webpack_public_path__ + "sprite.svg#domodedovo-usage",
      toString: function () {
        return this.url;
      }
    }